import React from 'react';
import FormGroup from './FormGroup';

export interface FormTextAreaProps {
  name?: string;
  register?: any;
  label?: string;
  defaultValue?: any;
  placeholder?: string;
  error?: any;
  errorMessage?: string;
  required?: boolean;
  extraRowClasses?: string;
  className?: string;
  children?: React.ReactNode;
  autoFocus?: boolean;
  disabled?: boolean;
  maxlength?: number;
  rows?: number;
  helpContent?: any;
  testId?: string;
}

const FormTextArea = ({
  label,
  name,
  defaultValue,
  placeholder,
  register,
  error,
  errorMessage,
  required,
  extraRowClasses = 'align-items-start',
  className,
  children,
  autoFocus,
  disabled,
  maxlength,
  rows,
  helpContent,
  testId,
}: FormTextAreaProps) => {
  const [count, setCount] = React.useState(
    typeof defaultValue === 'string' ? defaultValue.length : 0
  );

  return (
    <FormGroup
      label={label}
      error={error}
      errorMessage={errorMessage}
      required={required}
      extraRowClasses={extraRowClasses}
      helpContent={helpContent}
    >
      <div className="flex">
        <textarea
          {...(name ? register(name, { required }) : {})}
          aria-label={label}
          name={name}
          placeholder={placeholder}
          className={`form-control ${className || ''}`}
          rows={rows ?? 6}
          defaultValue={defaultValue}
          disabled={disabled ?? false}
          maxLength={maxlength}
          onChange={(e) => setCount(e.target.value.length)}
          autoFocus={autoFocus ?? false}
          data-cy={testId}
        />
        {children}
      </div>
      <div
        style={{
          textAlign: 'right',
          color: maxlength != null && maxlength - count < 0 ? 'red' : 'unset',
        }}
      >
        {maxlength != null && <span>{maxlength - count}</span>}
      </div>
    </FormGroup>
  );
};

export default FormTextArea;
